import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from '../components/AdminNavbar';

const AdminDashboardLayout = () => (
  <div className="min-h-screen bg-slate-50/70">
    <AdminNavbar />
    <main className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
      <Outlet />
    </main>
  </div>
);

export default AdminDashboardLayout;
